/* SA · Empuje de compra — entrega mañana, barra de envío gratis y sugerencias al pagar */
(function () {
  'use strict';

  var C = window.SA_EMPUJE || {};
  var UMBRAL = C.umbralEnvioGratis || 4500;
  var CORTE = C.horaCorte || 14;
  var DIAS_ENVIO = C.diasEnvio || [1, 2, 3, 4, 5];
  var DIAS_REPARTO = C.diasReparto || [1, 2, 3, 4, 5];
  var FESTIVOS = C.festivos || [];
  var RAIZ = (C.raiz || '/').replace(/\/?$/, '/');
  var N_SUGERENCIAS = C.sugerencias || 4;
  var QUEDAN_POCAS = C.avisoQuedanPocas || 5; /* muestra "Solo quedan X" con el stock real */
  var QUEDAN_CAJAS = C.avisoQuedanCajas || 20; /* tarjetas: "Quedan X cajas" solo si hay 20 o menos */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var moneda = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  function euros(c) { return moneda.format((c || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  var sesion = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var fetchOriginal = window.fetch.bind(window);

  var ICONO_CAMION = '<svg class="sa-eta__icono" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 6.5h11v9H3zM14 9.5h3.6l3.4 3.4v2.6h-7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.9" fill="var(--sa-eta-bg, #fff)" stroke="currentColor" stroke-width="1.8"/><circle cx="17" cy="17" r="1.9" fill="var(--sa-eta-bg, #fff)" stroke="currentColor" stroke-width="1.8"/></svg>';

  /* ------------------------------------------------------------------ */
  /* 1. ¿Cuándo llega?                                                   */
  /* ------------------------------------------------------------------ */
  function ahoraMadrid() {
    var partes = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { partes[p.type] = p.value; });
    /* Fecha "de pared" de Madrid guardada en UTC para operar sin líos de zona */
    return new Date(Date.UTC(+partes.year, +partes.month - 1, +partes.day, +partes.hour % 24, +partes.minute, +partes.second));
  }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function esDia(d, dias) { return dias.indexOf(d.getUTCDay()) !== -1 && FESTIVOS.indexOf(iso(d)) === -1; }
  function sumarDia(d) { var n = new Date(d); n.setUTCDate(n.getUTCDate() + 1); return n; }

  function calcularEntrega() {
    var ahora = ahoraMadrid();
    var hoy = new Date(ahora); hoy.setUTCHours(0, 0, 0, 0);
    var segundosHoy = ahora.getUTCHours() * 3600 + ahora.getUTCMinutes() * 60 + ahora.getUTCSeconds();
    var saleHoy = esDia(hoy, DIAS_ENVIO) && segundosHoy < CORTE * 3600;

    var salida = new Date(hoy);
    if (!saleHoy) { do { salida = sumarDia(salida); } while (!esDia(salida, DIAS_ENVIO)); }
    var llegada = salida;
    do { llegada = sumarDia(llegada); } while (!esDia(llegada, DIAS_REPARTO));

    var dias = Math.round((llegada - hoy) / 864e5);
    var diasCosecha = Math.round((salida - hoy) / 864e5);

    return {
      manana: dias === 1 && saleHoy,
      cuando: nombreDia(llegada, dias),          /* "mañana" o "el martes 29" */
      cosecha: nombreDia(salida, diasCosecha),   /* "hoy", "mañana" o "el lunes 28" */
      restan: saleHoy ? CORTE * 3600 - segundosHoy : 0
    };
  }

  /* Día en lenguaje natural: hoy / mañana / el lunes 28 (y el mes si queda lejos) */
  function nombreDia(fecha, dias) {
    if (dias === 0) return 'hoy';
    if (dias === 1) return 'mañana';
    var t = 'el ' + ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'][fecha.getUTCDay()] + ' ' + fecha.getUTCDate();
    if (dias >= 7) t += ' de ' + ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'][fecha.getUTCMonth()];
    return t;
  }

  /* Próxima cosecha para un producto YA agotado hoy: el de hoy ya voló, así que
     saltamos siempre al siguiente día de envío válido (nunca "hoy"). */
  function proximaCosechaTrasHoy() {
    var hoy = ahoraMadrid();
    hoy.setUTCHours(0, 0, 0, 0);
    var d = new Date(hoy);
    do { d = sumarDia(d); } while (!esDia(d, DIAS_ENVIO));
    var dias = Math.round((d - hoy) / 864e5);
    return nombreDia(d, dias);
  }

  /* Estado de cosecha de UN producto según su inventario:
     <= -1000  -> fuera de temporada (cierre deliberado, ver memoria de la tienda)
     <= 0      -> agotado pero en temporada: próxima cosecha real (sin "hoy", ya voló)
     > 0       -> con stock: reutiliza el cálculo general (puede dar "hoy" si toca) */
  function estadoCosechaProducto(inv) {
    if (inv <= -1000) return { tipo: 'fuera' };
    if (inv > 0) {
      var e = calcularEntrega();
      if (e.restan > 0) return { tipo: 'hoy' }; /* hoy es día de cosecha y aún no son las 14:00 */
      return { tipo: 'proxima', cuando: e.cosecha };
    }
    return { tipo: 'proxima', cuando: proximaCosechaTrasHoy() };
  }

  function formatoRestante(seg) {
    var minutos = Math.max(1, Math.ceil(seg / 60));
    var h = Math.floor(minutos / 60);
    var m = minutos % 60;
    if (h === 0) return m + ' min';
    return h + ' h' + (m ? ' ' + m + ' min' : '');
  }

  function pintarEntrega() {
    var nodos = document.querySelectorAll('[data-sa-eta]');
    if (!nodos.length) return;
    var e = calcularEntrega();
    var hora = (CORTE < 10 ? '0' : '') + CORTE + ':00';
    var nota = C.notaUrgente ? '<span class="sa-eta__nota">' + esc(C.notaUrgente) + '</span>' : '';

    nodos.forEach(function (n) {
      var tipo = n.getAttribute('data-sa-eta');
      if (tipo === 'card') return; /* las tarjetas se pintan aparte, con su propio stock */

      var invAttr = n.getAttribute('data-sa-inv');
      var inv = invAttr === null ? null : parseInt(invAttr, 10);

      if (inv !== null && inv <= -1000) { n.hidden = true; return; } /* fuera de temporada: nada */

      if (inv !== null && inv <= 0) {
        /* agotado en temporada: solo decimos cuándo vuelve, sin invitar a pedir ahora */
        var cuando = proximaCosechaTrasHoy();
        var htmlAgotado = ICONO_CAMION + '<div class="sa-eta__texto"><p class="sa-eta__linea sa-eta__linea--proxima">Próxima cosecha: <b>' + cuando + '</b></p></div>';
        if (n.__saHtml !== htmlAgotado) { n.innerHTML = htmlAgotado; n.__saHtml = htmlAgotado; }
        n.hidden = false;
        n.classList.remove('sa-eta--manana');
        return;
      }

      var html;
      /* Cuándo cosechamos y cuándo lo recibes; "con envío urgente" siempre debajo */
      var yo = (tipo === 'pdp' || tipo === 'cajon') ? 'Pídelo' : 'Pide';
      html = (e.manana
        ? '<p class="sa-eta__linea">' + yo + ' antes de las ' + hora + ': cosechamos <b>hoy</b> y <strong>lo recibes mañana</strong></p>' +
          '<p class="sa-eta__sub"><span class="sa-eta__reloj">Quedan ' + formatoRestante(e.restan) + '</span>' + (nota ? ' · ' + nota : '') + '</p>'
        : '<p class="sa-eta__linea">' + yo + (e.restan > 0 ? ' antes de las ' + hora : ' hoy') + ': cosechamos <b>' + e.cosecha + '</b> y <strong>lo recibes ' + e.cuando + '</strong></p>' +
          (nota ? '<p class="sa-eta__sub">' + nota + '</p>' : ''));
      html = ICONO_CAMION + '<div class="sa-eta__texto">' + html + '</div>';
      if (n.__saHtml !== html) { n.innerHTML = html; n.__saHtml = html; }
      n.hidden = false;
      n.classList.toggle('sa-eta--manana', e.manana);
    });
  }

  /* Insignia de cosecha en las tarjetas de producto (listados y home) */
  function pintarBadgesCosecha() {
    var nodos = document.querySelectorAll('[data-sa-eta="card"]');
    if (!nodos.length) return;

    nodos.forEach(function (n) {
      var envoltura = n.closest('.card-wrapper');
      var invAttr = envoltura && envoltura.getAttribute('data-sa-inv');
      var inv = (invAttr === null || invAttr === undefined || invAttr === '') ? NaN : parseInt(invAttr, 10);
      var nativa = envoltura && envoltura.querySelector('.card__badge .badge');

      if (isNaN(inv)) { n.hidden = true; return; }

      var estado = estadoCosechaProducto(inv);

      if (estado.tipo === 'fuera') {
        n.hidden = true;
        if (nativa) {
          if (nativa.__saOriginal === undefined) nativa.__saOriginal = nativa.textContent;
          nativa.textContent = 'Fuera de temporada';
          nativa.classList.add('sa-badge-fuera');
          nativa.hidden = false;
        }
        return;
      }

      /* "Cosechando hoy" (antes del corte) y "Quedan X cajas" (stock real, solo si
         quedan pocas: los stocks altos son de relleno y no dicen nada al cliente). */
      var nodoQ = envoltura.querySelector('[data-sa-quedan]');
      var quedan = nodoQ ? parseInt(nodoQ.getAttribute('data-sa-quedan'), 10) || 0 : 0;
      var pocas = quedan > 0 && quedan <= QUEDAN_CAJAS;
      var hoy = estado.tipo === 'hoy';
      if (!hoy && !pocas) { n.hidden = true; return; }

      var textoQ = pocas ? '<span class="sa-badge-cosecha__quedan">' + (quedan === 1 ? 'Queda 1 caja' : 'Quedan ' + quedan + ' cajas') + '</span>' : '';
      var texto = '<span class="sa-badge-cosecha__punto" aria-hidden="true"></span><span>' +
        (hoy ? 'Cosechando hoy' + (pocas ? '<span class="sa-badge-cosecha__sep"> · </span>' : '') : '') + textoQ + '</span>';
      if (n.__saTexto !== texto) { n.innerHTML = texto; n.__saTexto = texto; }
      n.className = 'sa-badge-cosecha sa-badge-cosecha--hoy';
      n.hidden = false;
    });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Barra de envío gratis                                            */
  /* ------------------------------------------------------------------ */
  var barra = { span: null, original: '', progreso: null, contenedor: null };
  var ultimoTotal = null;
  var ultimasUnidades = 0;

  function prepararBarra() {
    var mensaje = document.querySelector('.utility-bar .announcement-bar__message');
    if (!mensaje) return;
    barra.contenedor = mensaje.closest('.utility-bar');
    barra.span = mensaje.querySelector('span') || mensaje;
    barra.original = barra.span.innerHTML;
    barra.contenedor.classList.add('sa-barra');
    barra.progreso = document.createElement('div');
    barra.progreso.className = 'sa-barra__progreso';
    barra.progreso.setAttribute('aria-hidden', 'true');
    barra.progreso.innerHTML = '<i></i>';
    barra.contenedor.appendChild(barra.progreso);
    var vivo = document.createElement('p');
    vivo.className = 'visually-hidden'; vivo.setAttribute('aria-live', 'polite'); vivo.id = 'sa-envio-vivo';
    barra.contenedor.appendChild(vivo);
  }

  function textoEnvio(total, unidades, corto) {
    if (!unidades) return null;
    if (total >= UMBRAL) return corto ? '¡Enhorabuena! Tu envío es <strong>GRATIS</strong> 🎉' : '¡Enhorabuena! Tu envío es <strong>totalmente GRATIS</strong> 🎉';
    return 'Te faltan <strong>' + euros(UMBRAL - total) + '</strong> para el envío GRATIS';
  }

  function bloqueMini(total, unidades) {
    var pct = Math.min(100, Math.round((total / UMBRAL) * 100));
    return '<p class="sa-envio-mini__txt">' + textoEnvio(total, unidades, true) + '</p>' +
      '<div class="sa-envio-mini__barra" aria-hidden="true"><i style="width:' + pct + '%"></i></div>';
  }

  /* Rellena la mini barra; si ya existe, solo cambia texto y ancho para que se anime */
  function rellenarMini(mini, total, unidades) {
    var txt = mini.querySelector('.sa-envio-mini__txt');
    var i = mini.querySelector('.sa-envio-mini__barra i');
    if (txt && i) {
      txt.innerHTML = textoEnvio(total, unidades, true);
      i.style.width = Math.min(100, Math.round((total / UMBRAL) * 100)) + '%';
    } else {
      mini.innerHTML = bloqueMini(total, unidades);
    }
    mini.classList.toggle('sa-envio-mini--ok', total >= UMBRAL);
  }

  function asegurarMini(padre, antesDe, clase) {
    if (!padre) return null;
    var mini = padre.querySelector('.sa-envio-mini');
    if (!mini) {
      mini = document.createElement('div');
      mini.className = 'sa-envio-mini ' + (clase || '');
      if (antesDe && antesDe.parentNode === padre) padre.insertBefore(mini, antesDe); else padre.appendChild(mini);
    }
    return mini;
  }

  function actualizarEnvio(total, unidades) {
    quitarPendiente();
    var ok = total >= UMBRAL;
    var pct = Math.min(100, (total / UMBRAL) * 100);

    if (barra.span) {
      var txt = textoEnvio(total, unidades);
      barra.span.innerHTML = txt || barra.original;
      barra.contenedor.classList.toggle('sa-barra--activa', !!unidades);
      barra.contenedor.classList.toggle('sa-barra--gratis', !!unidades && ok);
      barra.progreso.firstChild.style.width = (unidades ? pct : 0) + '%';
      var vivo = document.getElementById('sa-envio-vivo');
      if (vivo && ultimoTotal !== null && ultimoTotal !== total) vivo.textContent = (txt || '').replace(/<[^>]+>/g, '');
    }

    /* Ventana "Añadido al carrito" del tema */
    var noti = document.getElementById('cart-notification');
    if (noti) {
      var links = noti.querySelector('.cart-notification__links');
      var m1 = asegurarMini(links ? links.parentNode : noti, links, 'sa-envio-mini--noti');
      if (m1) { m1.hidden = !unidades; if (unidades) rellenarMini(m1, total, unidades); }
    }

    /* Página del carrito */
    var ctas = document.querySelector('#main-cart-footer .cart__ctas, .cart__footer .cart__ctas');
    if (ctas) {
      var m2 = asegurarMini(ctas.parentNode, ctas, 'sa-envio-mini--carrito');
      if (m2) { m2.hidden = !unidades; if (unidades) rellenarMini(m2, total, unidades); }
    }

    /* Carrito lateral */
    decorarCajon();
    pintarCajon(total, unidades);

    /* Ventana de sugerencias (si está abierta) */
    var mU = document.querySelector('.sa-upsell .sa-envio-mini');
    if (mU) rellenarMini(mU, total, unidades);
    var go = document.querySelector('.sa-upsell__total');
    if (go) go.textContent = euros(total);

    if (ultimoTotal !== null && ultimoTotal < UMBRAL && ok) celebrar();
    ultimoTotal = total;
    ultimasUnidades = unidades;
  }

  /* ------------------------------------------------------------------ */
  /* 2a. Tarjetas de producto: marcar lo que ya está en el carrito       */
  /* ------------------------------------------------------------------ */
  function marcarTarjetas(items) {
    var cant = {};
    (items || []).forEach(function (it) {
      var h = it.handle || it.h;
      if (h) cant[h] = (cant[h] || 0) + (it.quantity || it.q || 0);
    });
    document.querySelectorAll('.card-wrapper').forEach(function (w) {
      var a = w.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var q = cant[decodeURIComponent(m[1])] || 0;
      var viejo = w.querySelector('.sa-en-carrito');
      if (viejo) viejo.remove();
      var boton = w.querySelector('.quick-add__submit');
      w.classList.toggle('sa-tarjeta--en-carrito', q > 0);
      if (!boton) return;
      var mas = boton.querySelector('.sa-mas');
      if (q > 0 && !boton.disabled) {
        /* El botón sigue añadiendo: solo cambia de color y dice que ya lo tienes */
        etiquetarBoton(boton, '✓ En tu carrito' + (q > 1 ? ' (' + q + ')' : ''));
        if (!mas) {
          mas = document.createElement('span');
          mas.className = 'sa-mas';
          mas.setAttribute('aria-hidden', 'true');
          mas.textContent = '+';
          boton.insertBefore(mas, boton.querySelector('.loading__spinner, .loading-overlay__spinner') || null);
        }
        boton.classList.add('sa-boton-en-carrito');
        boton.title = 'Añadir otra';
      } else {
        etiquetarBoton(boton, null);
        if (mas) mas.remove();
        boton.classList.remove('sa-boton-en-carrito');
        boton.removeAttribute('title');
      }
    });
  }

  /* Cambia el texto del botón rápido sin tocar el resto (spinner, icono…) */
  function etiquetarBoton(boton, texto) {
    var nodo = null;
    for (var i = 0; i < boton.childNodes.length; i++) {
      var n = boton.childNodes[i];
      if (n.nodeType === 1 && n.tagName === 'SPAN' && !n.classList.contains('sold-out-message') && !n.classList.contains('icon-wrap') && !n.classList.contains('sa-mas')) { nodo = n; break; }
      if (n.nodeType === 3 && n.textContent.trim()) { nodo = n; break; }
    }
    if (!nodo) return;
    if (boton.__saOriginal == null) boton.__saOriginal = nodo.textContent;
    var nuevo = texto == null ? boton.__saOriginal : texto;
    if (nodo.textContent !== nuevo) nodo.textContent = nuevo;
  }

  /* ------------------------------------------------------------------ */
  /* 2b. Carrito lateral: barra de envío, entrega y "seguir comprando"   */
  /* ------------------------------------------------------------------ */
  function decorarCajon() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return false;
    var cambiado = false;
    var cabecera = cd.querySelector('.drawer__header');
    if (cabecera && !cd.querySelector('.sa-envio-mini--cajon')) {
      var mini = document.createElement('div');
      mini.className = 'sa-envio-mini sa-envio-mini--cajon';
      cabecera.insertAdjacentElement('afterend', mini);
      cambiado = true;
    }
    var titulo = cd.querySelector('.drawer__heading');
    if (titulo && !titulo.querySelector('.sa-cajon-n')) {
      var n = document.createElement('span');
      n.className = 'sa-cajon-n';
      titulo.appendChild(n);
      cambiado = true;
    }
    var ctas = cd.querySelector('.drawer__footer .cart__ctas');
    if (ctas && !cd.querySelector('[data-sa-eta="cajon"]')) {
      var eta = document.createElement('div');
      eta.className = 'sa-eta sa-eta--cajon';
      eta.setAttribute('data-sa-eta', 'cajon');
      eta.hidden = true;
      ctas.parentNode.insertBefore(eta, ctas);
      cambiado = true;
    }
    if (ctas && !cd.querySelector('.sa-cajon-seguir')) {
      var seguir = document.createElement('button');
      seguir.type = 'button';
      seguir.className = 'sa-cajon-seguir';
      seguir.textContent = 'o seguir comprando';
      seguir.addEventListener('click', function () { if (typeof cd.close === 'function') cd.close(); });
      ctas.insertAdjacentElement('afterend', seguir);
      cambiado = true;
    }
    if (cambiado) pintarEntrega();
    return cambiado;
  }

  function pintarCajon(total, unidades) {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var mini = cd.querySelector('.sa-envio-mini--cajon');
    if (mini) {
      mini.hidden = !unidades;
      if (unidades) rellenarMini(mini, total, unidades);
    }
    var n = cd.querySelector('.sa-cajon-n');
    if (n) { n.textContent = unidades ? String(unidades) : ''; n.hidden = !unidades; }
  }

  /* El tema repinta el carrito lateral entero en cada cambio: volvemos a decorarlo */
  function vigilarCajon() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !window.MutationObserver) return;
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        if (decorarCajon() && ultimoTotal !== null) pintarCajon(ultimoTotal, ultimasUnidades);
      });
    }).observe(cd, { childList: true, subtree: true });
  }

  /* Al añadir un producto NO abrimos el carrito lateral: solo lo actualizamos
     y mostramos un aviso pequeño con "Ver carrito" */
  function silenciarCajon() {
    if (!window.customElements) return;
    customElements.whenDefined('cart-drawer').then(function () {
      var cd = document.querySelector('cart-drawer');
      if (!cd || cd.__saSilencio || typeof cd.renderContents !== 'function') return;
      cd.__saSilencio = true;
      var original = cd.renderContents;
      cd.renderContents = function (estado) {
        var abrir = cd.open;
        cd.open = function () {};
        try { original.call(cd, estado); } finally {
          /* el tema abre el cajón en un setTimeout: devolvemos "open" justo después */
          setTimeout(function () { cd.open = abrir; }, 0);
        }
        avisoAnadido(estado);
      };
    });
  }

  function abrirCajon() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') cd.open(document.getElementById('cart-icon-bubble'));
    else window.location.href = RAIZ + 'cart';
  }

  function avisoAnadido(estado) {
    var previo = document.querySelector('.sa-aviso');
    if (previo) previo.remove();
    var img = estado && (estado.image || (estado.featured_image && estado.featured_image.url));
    var titulo = estado && estado.product_title;
    var aviso = document.createElement('div');
    aviso.className = 'sa-aviso';
    aviso.setAttribute('role', 'status');
    aviso.innerHTML =
      (img ? '<img class="sa-aviso__img" src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="48" height="48">' : '') +
      '<div class="sa-aviso__txt"><strong>✓ Añadido a tu carrito</strong>' + (titulo ? '<span>' + esc(titulo) + '</span>' : '') + '</div>' +
      '<button type="button" class="sa-aviso__ver">Ver carrito</button>';
    document.body.appendChild(aviso);
    requestAnimationFrame(function () { aviso.classList.add('sa-aviso--visible'); });

    var temporizadorAviso;
    function cerrar() {
      clearTimeout(temporizadorAviso);
      aviso.classList.remove('sa-aviso--visible');
      setTimeout(function () { aviso.remove(); }, 300);
    }
    temporizadorAviso = setTimeout(cerrar, 4000);
    aviso.addEventListener('mouseenter', function () { clearTimeout(temporizadorAviso); });
    aviso.addEventListener('mouseleave', function () { temporizadorAviso = setTimeout(cerrar, 2000); });
    aviso.querySelector('.sa-aviso__ver').addEventListener('click', function () { cerrar(); abrirCajon(); });

    var icono = document.getElementById('cart-icon-bubble');
    if (icono && !reduceMotion) {
      icono.classList.remove('sa-bote');
      void icono.offsetWidth;
      icono.classList.add('sa-bote');
    }
  }

  function refrescarCajon(secciones) {
    if (!secciones) return;
    var cd = document.querySelector('cart-drawer');
    var actual = document.getElementById('CartDrawer');
    if (cd && actual && secciones['cart-drawer']) {
      var nuevo = new DOMParser().parseFromString(secciones['cart-drawer'], 'text/html').getElementById('CartDrawer');
      if (nuevo) {
        actual.innerHTML = nuevo.innerHTML;
        cd.classList.remove('is-empty');
        var capa = cd.querySelector('#CartDrawer-Overlay');
        if (capa && typeof cd.close === 'function') capa.addEventListener('click', cd.close.bind(cd));
      }
    }
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && secciones['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(secciones['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) burbuja.innerHTML = b.innerHTML;
    }
  }

  function celebrar() {
    if (barra.contenedor) {
      barra.contenedor.classList.remove('sa-barra--celebra');
      void barra.contenedor.offsetWidth;
      barra.contenedor.classList.add('sa-barra--celebra');
      setTimeout(function () { barra.contenedor && barra.contenedor.classList.remove('sa-barra--celebra'); }, 1800);
    }
    if (reduceMotion) return;
    var destinos = [barra.contenedor, document.querySelector('.sa-upsell .sa-envio-mini'), document.querySelector('#cart-notification .sa-envio-mini'), document.querySelector('cart-drawer.active .sa-envio-mini--cajon')];
    destinos.forEach(function (d) {
      if (!d || !d.getClientRects().length) return;
      var capa = document.createElement('div');
      capa.className = 'sa-confeti';
      var colores = ['#f9e547', '#88b04b', '#910f3f', '#f2efdd', '#ffffff'];
      for (var i = 0; i < 22; i++) {
        var p = document.createElement('i');
        p.style.left = (Math.random() * 100) + '%';
        p.style.background = colores[i % colores.length];
        p.style.animationDelay = (Math.random() * 0.25) + 's';
        p.style.setProperty('--x', (Math.random() * 60 - 30) + 'px');
        p.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
        capa.appendChild(p);
      }
      if (getComputedStyle(d).position === 'static') d.style.position = 'relative';
      d.appendChild(capa);
      setTimeout(function () { capa.remove(); }, 1600);
    });
  }

  function quitarPendiente() { document.documentElement.classList.remove('sa-envio--actualizando'); }

  var temporizador;
  function refrescarCarrito(retraso) {
    clearTimeout(temporizador);
    temporizador = setTimeout(function () {
      fetchOriginal(RAIZ + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          actualizarEnvio(cart.total_price, cart.item_count);
          marcarTarjetas(cart.items);
          pintarFlotante(cart);
          /* El tema a veces repinta el pie del carrito después: segunda pasada */
          setTimeout(function () { actualizarEnvio(cart.total_price, cart.item_count); }, 700);
        })
        .catch(quitarPendiente);
    }, retraso == null ? 60 : retraso);
  }

  /* Escuchamos cualquier cambio en el carrito, venga de donde venga */
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promesa = fetchOriginal.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      document.documentElement.classList.add('sa-envio--actualizando');
      promesa.then(function (r) {
        if (!r || !r.ok) return quitarPendiente();
        /* /cart/change y /cart/update ya devuelven el carrito: actualizamos al instante */
        r.clone().json().then(function (j) {
          if (j && typeof j.total_price === 'number' && typeof j.item_count === 'number') {
            actualizarEnvio(j.total_price, j.item_count);
            if (j.items) { marcarTarjetas(j.items); pintarFlotante(j); }
          }
        }).catch(function () {});
        refrescarCarrito();
      }).catch(quitarPendiente);
    }
    return promesa;
  };

  /* ------------------------------------------------------------------ */
  /* 3. Sugerencias al finalizar compra                                  */
  /* ------------------------------------------------------------------ */
  var CLAVE_CACHE = 'sa_mas_vendidos_v2';
  var cargaMasVendidos = null;

  function masVendidos() {
    if (cargaMasVendidos) return cargaMasVendidos;
    var cache = sesion.get(CLAVE_CACHE);
    if (cache) {
      try {
        var c = JSON.parse(cache);
        if (Date.now() - c.t < 10 * 60 * 1000) return (cargaMasVendidos = Promise.resolve(c.d));
      } catch (e) {}
    }
    cargaMasVendidos = fetchOriginal(RAIZ + 'collections/all?sort_by=best-selling&section_id=sa-mas-vendidos', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.querySelector('[data-sa-mas-vendidos]');
        var datos = s ? JSON.parse(s.textContent) : [];
        sesion.set(CLAVE_CACHE, JSON.stringify({ t: Date.now(), d: datos }));
        return datos;
      })
      .catch(function () { cargaMasVendidos = null; return []; });
    return cargaMasVendidos;
  }

  function conLimite(promesa, ms, porDefecto) {
    return Promise.race([promesa, new Promise(function (res) { setTimeout(function () { res(porDefecto); }, ms); })]);
  }

  var botonOrigen = null;

  function continuarAlPago() {
    if (botonOrigen && document.body.contains(botonOrigen)) {
      var b = botonOrigen;
      b.setAttribute('data-sa-paso', '1');
      b.click();
      /* Si por lo que sea no sale de la página, la próxima vez vuelve a preguntar */
      setTimeout(function () { b.removeAttribute('data-sa-paso'); }, 1500);
      return;
    }
    window.location.href = RAIZ + 'checkout';
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
    if (!btn) return;
    if (btn.hasAttribute('data-sa-paso') || btn.disabled) return;
    if (modal) { ev.preventDefault(); return; }
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    botonOrigen = btn;
    btn.classList.add('sa-cargando');
    btn.setAttribute('aria-busy', 'true');

    var carrito = fetchOriginal(RAIZ + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    Promise.all([conLimite(masVendidos(), 2500, []), conLimite(carrito, 2500, null)]).then(function (res) {
      btn.classList.remove('sa-cargando');
      btn.removeAttribute('aria-busy');
      var cart = res[1];
      if (!cart) return continuarAlPago();
      var enCesta = {};
      cart.items.forEach(function (it) { enCesta[it.product_id] = true; });
      var lista = (res[0] || []).filter(function (p) { return !enCesta[p.id]; }).slice(0, N_SUGERENCIAS);
      if (!lista.length) return continuarAlPago();
      abrirSugerencias(lista, cart);
    });
  }, true);

  var modal = null;
  var huboCambios = false;

  function abrirSugerencias(lista, cart) {
    huboCambios = false;
    modal = document.createElement('div');
    modal.className = 'sa-upsell';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'sa-upsell-titulo');

    var items = lista.map(function (p) {
      var variante = p.vt && p.vt !== 'Default Title' ? ' · ' + esc(p.vt) : '';
      var pocas = typeof p.q === 'number' && p.q > 0 && p.q <= QUEDAN_POCAS ? '<span class="sa-upsell__pocas">Solo quedan ' + p.q + '</span>' : '';
      return '<li class="sa-upsell__item">' +
        '<a class="sa-upsell__img" href="' + esc(p.u) + '" tabindex="-1">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
        '<div class="sa-upsell__info">' + pocas + '<a class="sa-upsell__nombre" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
        '<span class="sa-upsell__meta">' + euros(p.p) + variante + '</span></div>' +
        '<button type="button" class="sa-upsell__add" data-variante="' + p.v + '" aria-label="Añadir ' + esc(p.t) + '">' +
        '<span class="sa-upsell__add-si">+ Añadir</span><span class="sa-upsell__add-ok">✓ Añadido</span></button>' +
        '</li>';
    }).join('');

    modal.innerHTML =
      '<div class="sa-upsell__fondo" data-sa-cerrar></div>' +
      '<div class="sa-upsell__panel" tabindex="-1">' +
        '<button type="button" class="sa-upsell__x" data-sa-cerrar aria-label="Volver a la tienda"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
        '<p class="sa-upsell__eyebrow">Cosecha limitada</p>' +
        '<h2 class="sa-upsell__titulo" id="sa-upsell-titulo">Que no se te escape</h2>' +
        '<p class="sa-upsell__sub">Lo más pedido de la temporada. Cuando se acaba la cosecha, se acaba.</p>' +
        '<div class="sa-envio-mini sa-envio-mini--upsell' + (cart.total_price >= UMBRAL ? ' sa-envio-mini--ok' : '') + '">' + bloqueMini(cart.total_price, cart.item_count) + '</div>' +
        '<ul class="sa-upsell__lista">' + items + '</ul>' +
        '<button type="button" class="button button--primary button--full-width sa-upsell__ir"><span>Finalizar compra · <span class="sa-upsell__total">' + euros(cart.total_price) + '</span></span></button>' +
      '</div>';

    var noti = document.querySelector('cart-notification');
    if (noti && typeof noti.close === 'function' && noti.querySelector('.cart-notification.active')) { try { noti.close(); } catch (e) {} }
    document.body.appendChild(modal);
    document.documentElement.classList.add('sa-sin-scroll');
    requestAnimationFrame(function () { modal.classList.add('sa-upsell--abierto'); });
    var panel = modal.querySelector('.sa-upsell__panel');
    panel.focus({ preventScroll: true });

    modal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-sa-cerrar]')) return cerrarSugerencias();
      if (ev.target.closest('.sa-upsell__ir')) { ev.target.closest('.sa-upsell__ir').classList.add('sa-cargando'); return continuarAlPago(); }
      var add = ev.target.closest('.sa-upsell__add');
      if (add) alternarProducto(add);
    });
    modal.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') cerrarSugerencias();
      if (ev.key === 'Tab') {
        var f = modal.querySelectorAll('button, a[href]:not([tabindex="-1"])');
        if (!f.length) return;
        var primero = f[0], ultimo = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === primero) { ev.preventDefault(); ultimo.focus(); }
        else if (!ev.shiftKey && document.activeElement === ultimo) { ev.preventDefault(); primero.focus(); }
      }
    });
  }

  function alternarProducto(btn) {
    if (btn.classList.contains('sa-cargando')) return;
    btn.classList.add('sa-cargando');
    var yaAnadido = btn.classList.contains('sa-upsell__add--ok');
    var peticion = yaAnadido
      ? window.fetch(RAIZ + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: btn.getAttribute('data-clave'), quantity: 0, sections: 'cart-drawer,cart-icon-bubble' }) })
      : window.fetch(RAIZ + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-variante'), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }) });

    peticion
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        huboCambios = true;
        if (!yaAnadido && j.items && j.items[0]) btn.setAttribute('data-clave', j.items[0].key);
        btn.classList.toggle('sa-upsell__add--ok', !yaAnadido);
        btn.setAttribute('aria-label', (!yaAnadido ? 'Quitar ' : 'Añadir ') + btn.closest('.sa-upsell__item').querySelector('.sa-upsell__nombre').textContent);
        if (j.sections) refrescarCajon(j.sections); else actualizarBurbuja();
      })
      .catch(function (err) {
        var meta = btn.closest('.sa-upsell__item').querySelector('.sa-upsell__meta');
        if (meta && err && err.description) { meta.textContent = err.description; }
      })
      .then(function () { btn.classList.remove('sa-cargando'); });
  }

  function actualizarBurbuja() {
    fetchOriginal(RAIZ + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var destino = document.getElementById('cart-icon-bubble');
        if (!destino || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var nuevo = doc.querySelector('.shopify-section') || doc.body;
        destino.innerHTML = nuevo.innerHTML;
      })
      .catch(function () {});
  }

  function cerrarSugerencias() {
    if (!modal) return;
    var m = modal; modal = null;
    m.classList.remove('sa-upsell--abierto');
    document.documentElement.classList.remove('sa-sin-scroll');
    setTimeout(function () { m.remove(); }, 250);
    if (botonOrigen && document.body.contains(botonOrigen)) botonOrigen.focus({ preventScroll: true });
    /* En la página del carrito, recargamos para ver lo añadido */
    if (huboCambios && document.querySelector('cart-items, #main-cart-items')) window.location.reload();
  }

  /* ------------------------------------------------------------------ */
  /* 4. Cesta flotante: pastilla abajo a la izquierda con lo que llevas  */
  /* ------------------------------------------------------------------ */
  var flotante = null;
  var flotanteUnidades = 0;
  var FOTOS_PASTILLA = 3;

  function crearFlotante() {
    var f = document.createElement('div');
    f.className = 'sa-flota';
    f.hidden = true;
    f.innerHTML =
      '<div class="sa-flota__panel" id="sa-flota-panel" role="dialog" aria-label="Resumen de tu cesta" hidden>' +
        '<div class="sa-flota__cabecera"><strong>Tu cesta</strong>' +
          '<button type="button" class="sa-flota__cerrar" aria-label="Cerrar resumen">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
          '</button></div>' +
        '<ul class="sa-flota__lista"></ul>' +
        '<p class="sa-flota__total"><span>Total</span><strong></strong></p>' +
        '<p class="sa-flota__envio"></p>' +
        '<button type="button" class="sa-flota__ir">Ir a la cesta</button>' +
      '</div>' +
      '<button type="button" class="sa-flota__pastilla" aria-expanded="false" aria-controls="sa-flota-panel">' +
        '<span class="sa-flota__fotos" aria-hidden="true"></span>' +
        '<span class="sa-flota__txt"><span class="sa-flota__uds"></span><strong class="sa-flota__suma"></strong></span>' +
        '<span class="sa-flota__barra" aria-hidden="true"><i></i></span>' +
      '</button>';
    document.body.appendChild(f);

    var pastilla = f.querySelector('.sa-flota__pastilla');
    pastilla.addEventListener('click', function () { alternarFlotante(); });
    f.querySelector('.sa-flota__cerrar').addEventListener('click', function () { alternarFlotante(false); pastilla.focus(); });
    f.querySelector('.sa-flota__ir').addEventListener('click', function () { alternarFlotante(false); abrirCajon(); });
    document.addEventListener('click', function (ev) { if (!f.contains(ev.target)) alternarFlotante(false); });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && f.classList.contains('sa-flota--abierta')) { alternarFlotante(false); pastilla.focus(); }
    });
    return f;
  }

  function alternarFlotante(abrir) {
    if (!flotante) return;
    if (abrir === undefined) abrir = !flotante.classList.contains('sa-flota--abierta');
    var panel = flotante.querySelector('.sa-flota__panel');
    flotante.classList.toggle('sa-flota--abierta', abrir);
    flotante.querySelector('.sa-flota__pastilla').setAttribute('aria-expanded', abrir ? 'true' : 'false');
    panel.hidden = !abrir;
  }

  function miniatura(url, ancho) {
    if (!url) return '';
    return esc(url) + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }

  /* Pinta la pastilla con el carrito completo (cart.js o la respuesta de /cart/change) */
  function pintarFlotante(cart) {
    if (!cart || !cart.items) return;
    /* En la página del carrito ya se ve todo: no hace falta */
    if (document.querySelector('#main-cart-items')) return;
    if (!flotante) flotante = crearFlotante();

    var unidades = cart.item_count || 0;
    if (!unidades) {
      alternarFlotante(false);
      flotante.classList.remove('sa-flota--visible');
      setTimeout(function () { if (!flotanteUnidades) flotante.hidden = true; }, 300);
      flotanteUnidades = 0;
      return;
    }

    var items = cart.items;
    var fotos = items.slice(0, FOTOS_PASTILLA).map(function (it) {
      return it.image ? '<img src="' + miniatura(it.image, 96) + '" alt="" width="32" height="32" loading="lazy">' : '<i></i>';
    }).join('');
    if (items.length > FOTOS_PASTILLA) fotos += '<b>+' + (items.length - FOTOS_PASTILLA) + '</b>';
    flotante.querySelector('.sa-flota__fotos').innerHTML = fotos;
    flotante.querySelector('.sa-flota__uds').textContent = unidades === 1 ? '1 producto' : unidades + ' productos';
    flotante.querySelector('.sa-flota__suma').textContent = euros(cart.total_price);
    flotante.querySelector('.sa-flota__pastilla').setAttribute('aria-label',
      'Tu cesta: ' + (unidades === 1 ? '1 producto' : unidades + ' productos') + ', ' + euros(cart.total_price) + '. Ver resumen');

    var ok = cart.total_price >= UMBRAL;
    flotante.classList.toggle('sa-flota--gratis', ok);
    flotante.querySelector('.sa-flota__barra i').style.width = Math.min(100, (cart.total_price / UMBRAL) * 100) + '%';

    flotante.querySelector('.sa-flota__lista').innerHTML = items.map(function (it) {
      var detalle = [it.variant_title, it.quantity > 1 ? '×' + it.quantity : ''].filter(Boolean).join(' · ');
      return '<li>' +
        (it.image ? '<img src="' + miniatura(it.image, 120) + '" alt="" width="40" height="40" loading="lazy">' : '<i></i>') +
        '<span class="sa-flota__nombre">' + esc(it.product_title) + (detalle ? '<small>' + esc(detalle) + '</small>' : '') + '</span>' +
        '<span class="sa-flota__precio">' + euros(it.final_line_price) + '</span>' +
      '</li>';
    }).join('');
    flotante.querySelector('.sa-flota__total strong').textContent = euros(cart.total_price);
    flotante.querySelector('.sa-flota__envio').innerHTML = textoEnvio(cart.total_price, unidades, true);

    var crece = unidades > flotanteUnidades && flotanteUnidades > 0;
    flotanteUnidades = unidades;
    flotante.hidden = false;
    requestAnimationFrame(function () { flotante.classList.add('sa-flota--visible'); });
    if (crece && !reduceMotion) {
      var p = flotante.querySelector('.sa-flota__pastilla');
      p.classList.remove('sa-bote');
      void p.offsetWidth;
      p.classList.add('sa-bote');
    }
  }

  /* ------------------------------------------------------------------ */
  /* Arranque                                                            */
  /* ------------------------------------------------------------------ */
  function iniciar() {
    prepararBarra();
    var ini = C.carrito || {};
    actualizarEnvio(ini.total || 0, ini.unidades || 0);
    marcarTarjetas(C.lineas);
    if (ini.unidades) refrescarCarrito(0); /* trae las líneas completas para la cesta flotante */
    vigilarCajon();
    silenciarCajon();
    pintarEntrega();
    pintarBadgesCosecha();
    setInterval(function () { pintarEntrega(); pintarBadgesCosecha(); }, 15000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { pintarEntrega(); pintarBadgesCosecha(); refrescarCarrito(0); } });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      refrescarCarrito(0);
      /* Al volver atrás desde la pantalla de pago, que vuelva a preguntar */
      document.querySelectorAll('[data-sa-paso]').forEach(function (b) { b.removeAttribute('data-sa-paso'); b.classList.remove('sa-cargando'); });
      var ir = document.querySelector('.sa-upsell__ir'); if (ir) ir.classList.remove('sa-cargando');
    });
    /* Precarga discreta de los más vendidos para que la ventana abra al instante */
    var precargar = function () { masVendidos(); };
    if ('requestIdleCallback' in window) requestIdleCallback(precargar, { timeout: 4000 }); else setTimeout(precargar, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
